export default __webpack_public_path__ + "static/media/Reception 4.a23908b1.jpg";